import React, { createContext } from "react";
import Loading from "./Loading";
import checkGroupAdminAccess from "src/queries/checkGroupAdminAccess";
const defaultPermission = {
    hasAdminAccess: false,
    hasUploadAccess: true,
    hasEditAccess: false,
    emailId: "",
};
export const PermissionsContext = createContext(defaultPermission);
const PermissionsContextProvider = PermissionsContext.Provider;
const GetPermissions = ({ children }) => {
    const { data, isLoading } = checkGroupAdminAccess();
    const permissions = {
        hasAdminAccess: data?.belongToAdminGroup,
        tokenClaim: data?.tokenClaim,
        emailId: data?.tokenClaim.email,
        hasEditAccess: false,
        hasUploadAccess: true,
    };
    if (isLoading) {
        return React.createElement(Loading, null);
    }
    return (React.createElement(PermissionsContextProvider, { value: permissions }, children));
};
export default GetPermissions;
